import { Teleport_default } from "../Teleport/Teleport.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/HoverCard/HoverCardPortal.vue?vue&type=script&setup=true&lang.ts
var HoverCardPortal_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "HoverCardPortal",
	props: {
		to: {
			type: null,
			required: false
		},
		disabled: {
			type: Boolean,
			required: false
		},
		defer: {
			type: Boolean,
			required: false
		},
		forceMount: {
			type: Boolean,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Teleport_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/HoverCard/HoverCardPortal.vue
var HoverCardPortal_default = HoverCardPortal_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { HoverCardPortal_default };
//# sourceMappingURL=HoverCardPortal.js.map